"use strict";

import axios from "axios";
import qs from "qs";

// Full config:  https://github.com/axios/axios#request-config
//axios.defaults.baseURL = "http://";
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.common['Origin'] = AUTH_TOKEN;

let hosts='https://service.chaunve.com';
let config = {
  baseURL: process.env.NODE_ENV !== 'production' ? hosts : hosts,
  // timeout: 60 * 1000, // Timeout
   //withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    //formData上传文件不做数据处理
    if (config.headers["Content-Type"] !="multipart/form-data"&&config.method=='post'){
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);


export default _axios;


// WEBPACK FOOTER //
// ./src/plugs/axios/axios.js